<template>
  <div class="wrap">
    <div class="chapter_box" v-if="!empty">
      <el-tree
        :data="list"
        node-key="chapterId"
        :props="{
          children: 'children',
          label: 'title',
        }"
        :default-expand-all="true"
      >
        <span
          class="custom-tree-node"
          :class="{ catalog: !data.parentId }"
          slot-scope="{ node, data }"
        >
          <span>
            <span class="left-icon" v-if="data.children">
              <img
                :src="
                  node.expanded
                    ? require('@/assets/images/icons/close.png')
                    : require('@/assets/images/icons/open.png')
                "
                alt=""
              />
            </span>
            <span class="left-dot" v-else> </span>
            <span>{{ data.title }}</span>
            <!-- <el-tag
              v-if="data.sz"
              style="margin-left: 10px"
              effect="dark"
              size="mini"
              >实训</el-tag
            >
            <el-tag
              v-if="data.mock"
              style="margin-left: 10px"
              effect="dark"
              type="warning"
              size="mini"
              >仿真实训</el-tag
            >
            <el-tag
              v-if="data.teamGrade"
              style="margin-left: 10px"
              effect="dark"
              type="success"
              size="mini"
              >评价</el-tag
            > -->
          </span>
          <span v-if="data.type == 'CHAPTER'">
            <el-button
              class="btn"
              size="mini"
              v-show="data.status == 'OPEN'"
              @click="goDetail(data)"
              >开始上课</el-button
            >
          </span>
        </span>
      </el-tree>
    </div>
    <el-empty description="暂无章节~" :image-size="200" v-else></el-empty>
  </div>
</template>

<script>
import { myTeam } from "@/api/team";
import uploadFile from "@/components/uploadFile";
export default {
  name: "chapters",
  components: {
    uploadFile,
  },
  data() {
    return {
      params: {
        classChapterId: "",
        fileId: "",
      },
      noTeam: false,
    };
  },
  created() {
    this.getMyTeam();
  },
  computed: {
    list() {
      return this.$store.state.chapterList;
    },
    empty() {
      return this.list && this.list.length > 0 ? false : true;
    },
  },
  methods: {
    goDetail(chapter) {
      if (this.noTeam) {
        this.$message.warning("上课之前请先创建团队并通过教师审核");
        return;
      }
      this.$router.push({
        path: "/courseDetail",
        query: {
          id: this.$route.query.id,
          classChapterId: chapter.classChapterId,
          chapterTitle: chapter.title,
        },
      });
    },
    getMyTeam() {
      this.$loading.show();
      myTeam({ classId: this.$route.query.id }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          if (res.data && res.data.status == "RESOLVE") {
            this.noTeam = false;
          } else {
            this.noTeam = true;
          }
        } else {
          console.log(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.wrap {
  margin-bottom: 30px;

  .chapter_box {
    background-color: #fff;
    ::v-deep .el-tree {
      .el-tree-node {
        .el-tree-node__content {
          height: 40px;
          border-bottom: 1px solid rgba(0, 0, 0, 0.05);
          .el-tree-node__expand-icon {
            display: none;
          }
        }
      }
    }
    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      padding: 0 16px;
      height: 40px;
      &.catalog {
        font-size: 17px;
        color: #303133;
        font-weight: bold;
        background-color: #0080802b;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
      }
      .left-icon {
        margin-right: 16px;
        img {
          width: 18px;
          height: 18px;
        }
      }
      .left-dot {
        display: inline-block;
        margin: 0 16px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: teal;
      }
      .btn {
        margin-left: 10px;
      }
    }
  }

  .catalog_row,
  .row {
    line-height: 40px;
    text-align: left;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    &.catalog_row {
      border-bottom: none;
    }
    &.row {
      padding: 0 15px;
      transition: all 0.3s ease;

      &:hover {
        background-color: rgb(245, 245, 245);
      }
    }

    .catalog_title,
    .title {
      display: inline-block;
      margin-left: 16px;
      max-width: 1010px;
      height: 40px;
      font-size: 16px;
      // font-weight: bold;
      color: #606266;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      vertical-align: middle;
      &.catalog_title {
        max-width: 100%;
        font-size: 17px;
        color: #303133;
        font-weight: bold;
      }
    }

    .btns {
      float: right;

      .btn {
        font-size: 14px;
        color: #1890ff;
        border-color: #1890ff;

        &:hover {
          background-color: #1890ff;
          color: #fff;
        }
      }
    }
  }
}
</style>